/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function TaskIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="1">
        <g id="icon-game copy">
          <circle
            id="Oval"
            cx="78.5"
            cy="78.5"
            r="77.5"
            fill={mainColor}
            stroke="white"
            stroke-width="2"
          />
        </g>
        <g id="list">
          <path
            id="Path"
            d="M110.198 92.6684L101.59 105.173L95.5145 100.132C94.8591 99.5861 93.8884 99.6841 93.3499 100.347C92.81 101.011 92.9053 101.992 93.5638 102.535L100.927 108.645C101.203 108.876 101.548 109 101.902 109C101.971 109 102.042 108.995 102.113 108.984C102.537 108.925 102.919 108.689 103.165 108.333L112.724 94.446C113.209 93.7415 113.038 92.7726 112.34 92.2811C111.641 91.7866 110.685 91.9623 110.198 92.6684Z"
            fill={secondaryColor}
          />
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M82 101C82 89.9723 90.9723 81 102 81C113.028 81 122 89.9723 122 101C122 112.028 113.028 121 102 121C90.9723 121 82 112.028 82 101ZM85.0769 101C85.0769 110.331 92.6692 117.923 102 117.923C111.331 117.923 118.923 110.331 118.923 101C118.923 91.6692 111.331 84.0769 102 84.0769C92.6692 84.0769 85.0769 91.6692 85.0769 101Z"
            fill={secondaryColor}
          />
          <path
            id="Shape_2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M76.5 102.093C75.6516 102.093 74.963 101.406 74.963 100.556C74.963 99.7056 75.6516 99.0185 76.5 99.0185H78.2507C79.4096 89.7932 85.6899 82.1603 94.1529 79.037H76.5C75.6516 79.037 74.963 78.35 74.963 77.5C74.963 76.65 75.6516 75.963 76.5 75.963H104.167C105.015 75.963 105.704 76.65 105.704 77.5C105.704 77.543 105.693 77.5824 105.682 77.6218C105.674 77.6499 105.666 77.678 105.662 77.7075C110.295 78.2808 114.531 80.1391 118 82.9257V54.715C118 44.3953 109.605 36 99.285 36H53.715C43.3953 36 35 44.3953 35 54.715V100.285C35 110.605 43.3953 119 53.715 119H84.8184C80.6269 114.587 78.037 108.643 78.037 102.093H76.5ZM76.5 54.4444H104.167C105.015 54.4444 105.704 55.1315 105.704 55.9815C105.704 56.8315 105.015 57.5185 104.167 57.5185H76.5C75.6516 57.5185 74.963 56.8315 74.963 55.9815C74.963 55.1315 75.6516 54.4444 76.5 54.4444ZM56.2588 106.164L66.7982 93.8694C67.35 93.2254 67.2762 92.2571 66.6322 91.7053C65.9897 91.152 65.0168 91.2257 64.465 91.8713L54.8616 103.072L48.987 98.6665C48.3077 98.1593 47.3455 98.2946 46.8352 98.9739C46.3264 99.6518 46.4632 100.616 47.1426 101.124L54.1684 106.395C54.4451 106.602 54.7694 106.702 55.0906 106.702C55.5256 106.702 55.956 106.518 56.2588 106.164ZM66.7982 70.8139L56.2588 83.1102C55.956 83.4637 55.5256 83.6481 55.0906 83.6481C54.7694 83.6481 54.4451 83.5482 54.1684 83.3407L47.1426 78.0702C46.4632 77.5615 46.3264 76.5978 46.8352 75.9199C47.3455 75.2406 48.3077 75.1038 48.987 75.6125L54.8616 80.0177L64.465 68.8157C65.0168 68.1702 65.9897 68.0964 66.6322 68.6497C67.2762 69.2015 67.35 70.1699 66.7982 70.8139ZM56.2588 61.5917L66.7982 49.2954C67.35 48.6514 67.2762 47.683 66.6322 47.1312C65.9897 46.5779 65.0168 46.6517 64.465 47.2972L54.8616 58.4991L48.987 54.094C48.3077 53.5852 47.3455 53.722 46.8352 54.4014C46.3264 55.0792 46.4632 56.043 47.1426 56.5517L54.1684 61.8222C54.4451 62.0297 54.7694 62.1296 55.0906 62.1296C55.5256 62.1296 55.956 61.9452 56.2588 61.5917Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

TaskIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
TaskIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(TaskIcon);
memoized.displayName = 'TaskIcon';
export default memoized;
